// extracted by mini-css-extract-plugin
export default {"description":"toggle-description_description__C0x1y","open":"toggle-description_open__cmM0Y","button":"toggle-description_button__mIFSZ"};